import * as React from "react";
import { Dayjs } from "dayjs";
import { Box } from "@mui/material";
import { DesktopTimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TimePickerProps } from "@mui/x-date-pickers/TimePicker";
import DatePickerComponentStyle from "./DatePickerComponentStyle";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
interface TimePickerComponentProps extends TimePickerProps<Dayjs> {
  labelText: string;
  onClick?: () => void;
}

const TimePickerComponent: React.FC<TimePickerComponentProps> = (props) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={"en-us"}>
      <Box
        {...DatePickerComponentStyle.mainBox}
        className={props.disabled ? "not-allowed-cursor" : undefined}
      >
        <label
          style={{
            ...DatePickerComponentStyle.dateTitle, cursor: props.disabled ? "not-allowed" : "default",
          }}
        >
          {props.labelText}
        </label>
        <DesktopTimePicker
          ampm={false}
          sx={DatePickerComponentStyle.datePickerSx}
          format={"HH:mm"}
          timeSteps={{ minutes: 1 }}
          closeOnSelect={false}
          slotProps={{
            ...props.slotProps,
            textField: {
              ...props.slotProps?.textField,
              placeholder: "",
            },
            field: {
              readOnly: false,
              ...props.slotProps?.field,
            },
          }}
          {...props}
        />
      </Box>
    </LocalizationProvider>
  );
};

export default TimePickerComponent;
